import { FormattedMessage } from 'react-intl';
import carImage from '../assets/Images/car.png';

export const CarCenter = () => (
    <div className="row-span-2 flex flex-col items-center justify-between">
        <p className="opacity-20 text-2vw tv:text-2vw font-bold text-center uppercase text-darkGrey mt-10">
            <FormattedMessage id="front" defaultMessage="Front" />
        </p>
        <img className="w-2/3 tv:w-4/5" src={carImage} alt="Car" />
        <p className="opacity-20 text-2vw tv:text-2vw font-bold text-center uppercase text-darkGrey mb-10">
            <FormattedMessage id="rear" defaultMessage="Rear" />
        </p>
    </div>
);
